<template>
    <div id="virtual-keyboard" v-show="shown" >
        <div class="simple-keyboard" ref="keyboard" draggable="true" @dragend="drag">
            <div class="header-section">
                <div class="drag-section"></div>
                <i class="fas fa-times close hide-keyboard-btn" @click="hideKeyboard"></i>
            </div>
        </div>
    </div>
</template>

<script>
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

export default {
    name: 'virtual-keyboard',
    props: [

    ],
    data() {
        return {
            keyboard: null,
        }
    },
    mounted() {
        this.keyboard = new Keyboard({
            onChange: input => this.onChange(input),
            onKeyPress: button => this.onKeyPress(button),
        });
    },
    methods: {
        drag(e) {
            let {x, y} = e
            this.$refs.keyboard.style.top = y + 'px';
            this.$refs.keyboard.style.left = x + 'px';
        },
        onChange(input) {
            this.currentInput.value = input;
            var event = new Event('input');
            this.currentInput.dispatchEvent(event, { bubbles: true });
        },
        onKeyPress(button) {
            if (button === "{shift}" || button === "{lock}") this.handleShift();
        },
        handleShift() {
            const currentLayout = this.keyboard.options.layoutName;
            const shiftToggle = currentLayout === "default" ? "shift" : "default";

            this.keyboard.setOptions({
                layoutName: shiftToggle
            });
        },
        showKeyboard() {
            this.shown = true;
        },
        hideKeyboard() {
            this.shown = false;
        }
    },
    computed: {
        currentInput (){
            return this.$store.state.currentInputElement;
        },
        shown: {
            set (value) {
                this.$store.state.virtualKeyboardShown = value;
            },
            get() {
                return this.$store.state.virtualKeyboardShown;
            }
        }
    },
    watch: {
        currentInput: function (newValue, oldValue) {
            if (oldValue != newValue) {
                this.keyboard.setInput(newValue.value);
            }
        }
    }
}
</script>

<style scoped>
.simple-keyboard {
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 9;
    max-width: 850px;
    padding: 10px;
    padding-top: 30px;
    border: 1px solid #dba3c4;
    border-radius: 10px;
}

#virtual-keyboard .close {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 15px;
    padding-top: 8px;
    font-size: 18px;
}

#virtual-keyboard .drag-section {
    width: 95%;
    height: 20px;
    position: absolute;
    top: 10px;
    left: 0;
    cursor: move;
}

.hg-theme-default .hg-row .hg-button {
    border: 1px solid var(--v-primary-lighten3);
    box-shadow: inset 0 0 4px 0px rgb(216 202 202);
}
</style>
